import { useContext } from 'react';
import { ClienteContext } from '../context/ClienteContext';

// ----------------------------------------------------------------------

const useCliente = () => useContext(ClienteContext);

export default useCliente;
